/*
 * @Description: schema相关工具集
 * @Author: fiveonelei
 * @Date: 2022-02-09 15:49:34
 * @FilePath: /app-monorepo-projects/packages/app-share/src/utils/schema.ts
 */
import { SCHEMA_MAP } from '@/constants/schema';
import { IHashMap } from '@/types/data';
import { loadWslSchemaAsync, loadWslUrlAsync } from '@/utils/load-wslib';
import type { SchemaOption } from '@tencent/wsl-schema';
import { IS_SSR } from '@/utils/env';

export function isWeiShiSchema(schema: string) {
  return /^weishi:\/\//.test(schema);
}

type SchemaMapKey = keyof typeof SCHEMA_MAP;

// addLogSour函数仅能在CSR阶段调用
export async function addLogSour(schema: string) {
  const wsUrl = await loadWslUrlAsync() as IHashMap;
  if (!wsUrl) return schema;
  const attachInfo = wsUrl.getAttachInfo();
  if (!attachInfo.reserves3) {
    return schema;
  }
  if (/logsour=/ig.test(schema)) {
    return schema;
  }
  const suffix = ~schema.indexOf('?') ? '&' : '?';
  return `${schema + suffix}logsour=${attachInfo.reserves3}`;
};

export function getSchemaFromExposureMaterial(exposureMaterialInfo: IHashMap = {}, source?: string) {
  const { common_label_scheme: commonLabelScheme, material_category: materialCategory } = exposureMaterialInfo;
  if (!commonLabelScheme) {
    const category: SchemaMapKey = SCHEMA_MAP[materialCategory as SchemaMapKey] ? materialCategory : 'unknown';
    if (category === 'camera') {
      return SCHEMA_MAP[category](exposureMaterialInfo, 'upload_from=15', source === 'banner');
    }
    return SCHEMA_MAP[category](exposureMaterialInfo, 'upload_from=15');
  }
  if (isWeiShiSchema(commonLabelScheme)) {
    return `${commonLabelScheme}&upload_from=15`;
  }
  return `weishi://webview?jump_url=${commonLabelScheme}&upload_from=15`;
}

export function appendVersionInfoToSchema(schema: string, versionInfo: IHashMap) {
  const { ios_min_version_str: iosMinVersionStr, android_min_version_str: androidMinVersionStr } = versionInfo;
  if (iosMinVersionStr) {
    return `${schema}&ios_min_version=${iosMinVersionStr}`;
  }
  if (androidMinVersionStr) {
    return `${schema}&android_min_version=${androidMinVersionStr}`;
  }
  return schema;
}

export async function openSchema(schema: string, option?: IHashMap) {
  if (IS_SSR) return;
  const wsSchema = await loadWslSchemaAsync();
  if (!wsSchema) return;
  wsSchema.openSchema(schema, option as SchemaOption); // SchemaOption的类型定义与实际不符，这里对其下类型
}

export function formatVideoCollectionSchema(
  collectionId: string,
  feedId: string,
  index: number,
) {
  return `weishi://videoCollection?cid=${collectionId}&feedId=${feedId}&index=${index}`;
}
